import LoginOrRegisterDispatch from "@/pages/login-or-register-dispatch";
import BaseApp from "../modules/base-app";

const LoginOrRegister = (props) => (
  <BaseApp {...props}>
    <LoginOrRegisterDispatch {...props} />
  </BaseApp>
);

export default LoginOrRegister;
